/**
 * @author Fernando Ruano
 * @file index.jsx
 * @description Roles Creation View Page.
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Components
import FormGenerator from '@nephro/components/FormGenerator';

// Helpers
import {
  bottomOptionsCreateEdit,
  formItemNameDesc
} from '@nephro/commons/helpers/utils';

// Styles
import styles from './styles.module.css';

const roleData = {};

/**
 * Roles Creation View
 * @param { Object } roleActions - Role Actions.
 * @param { Object } actions - App Actions.
 * @return { Node } React node.
 */
const RolesCreationView = ({ roleActions }) => {
  const history = useHistory();
  const { createRole } = roleActions;
  const { t: translate } = useTranslation();

  const onGoBack = () => {
    history.goBack();
  };

  // Function to get on submit form values
  const onFinish = (values) => {
    createRole(values, onGoBack);
  };

  return (
    <AppCardLayout>
      <div className="flex flex-col h-full px-7 pt-5 pb-7 ">
        <FormGenerator
          initialValues={roleData}
          onFinish={onFinish}
          items={formItemNameDesc(translate)}
          bottomOptions={bottomOptionsCreateEdit(
            onGoBack,
            translate,
            'create',
            styles.actionButton
          )}
        />
      </div>
    </AppCardLayout>
  );
};

/**
 * Component definition of proptypes.
 */
RolesCreationView.propTypes = {
  roleActions: PropTypes.shape({
    createRole: PropTypes.func.isRequired
  }).isRequired
};

export default RolesCreationView;
